import ActionColumnComponent from "../../components/ActionColumn/ActionColumn";

// Main columns configuration
export const getAllColumns = (viewModal, updateModal, deleteRecord) => {
  const actionColumn = ActionColumnComponent({ viewModal, updateModal, deleteRecord });

  return {
    "Household Members": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
      },
      {
        title: "Birth Date",
        dataIndex: "Birth Date",
        key: "birthdate",
      },
      {
        title: "Social Security Number",
        dataIndex: "Social Security Number",
        key: "socialsecuritynumber",
      },
      {
        title: "Blood Type",
        dataIndex: "Blood Type",
        key: "bloodtype",
      },
      {
        title: "Medical Condition",
        dataIndex: "Medical Condition",
        key: "medicalcondition",
      },
      {
        title: "Allergies",
        dataIndex: "Allergies",
        key: "allergies",
      },
      actionColumn,
    ],
    "Primary Doctor Contact Information": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
      },
      {
        title: "Phone Number",
        dataIndex: "Phone Number",
        key: "phonenumber",
      },
      actionColumn,
    ],
    "Pediatrician Contact Information": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
      },
      {
        title: "Phone Number",
        dataIndex: "Phone Number",
        key: "phonenumber",
      },
      actionColumn,
    ],
    "Out-of-State contact person": [
      { title: "Name", dataIndex: "Name", key: "name" },
      { title: "Phone Number", dataIndex: "Phone Number", key: "phonenumber" },
      { title: "Location", dataIndex: "Location", key: "location" },
      actionColumn,
    ],
    "Pet Information": [
      {
        title: "Pet Name",
        dataIndex: "Pet Name",
        key: "petname",
      },
      {
        title: "Type of Animal",
        dataIndex: "Type of Animal",
        key: "typeofanimal",
      },
      {
        title: "Color",
        dataIndex: "Color",
        key: "color",
      },
      {
        title: "Approx. Age",
        dataIndex: "Approx. Age",
        key: "approxage",
      },
      actionColumn,
    ],
    "School Name": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
      },
      {
        title: "Who's School",
        dataIndex: "Who's School",
        key: "whosschool",
      },
      {
        title: "Phone Number",
        dataIndex: "Phone Number",
        key: "phonenumber",
      },
      {
        title: "Street",
        dataIndex: "Street",
        key: "street",
      },
      {
        title: "City",
        dataIndex: "City",
        key: "city",
      },
      {
        title: "State",
        dataIndex: "State",
        key: "state",
      },
      actionColumn,
    ],
    "Workplace/Employer Name": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
      },
      {
        title: "Who's WorkPlace",
        dataIndex: "Who's WorkPlace",
        key: "whosworkplace",
      },
      {
        title: "Phone Number",
        dataIndex: "Phone Number",
        key: "phonenumber",
      },
      {
        title: "Street",
        dataIndex: "Street",
        key: "street",
      },
      {
        title: "City",
        dataIndex: "City",
        key: "city",
      },
      {
        title: "State",
        dataIndex: "State",
        key: "state",
      },
      actionColumn,
    ],
  };
};

// Usage example in your component:
// const { viewModal, updateModal, deleteRecord } = yourPropsOrContext;
// const AllColumnsData = getAllColumns(viewModal, updateModal, deleteRecord);
